export default "__VITE_ASSET__DYr5bYoD__"